/**
 * Shared UI mappings for issue display
 *
 * These are pure UI concerns - mapping backend types to React components/styles.
 * Does NOT duplicate backend definitions - just rendering logic.
 *
 * Used by:
 * - Drivers.tsx (issue badges)
 * - SitesPage.tsx (breakdown tiles)
 */

import {
    XCircle,
    AlertTriangle,
    Clock,
    HelpCircle,
    Info,
    Ban,
} from 'lucide-react';
import { IssueIconType, IssueSeverity } from '../services/api';

/**
 * Map backend icon types to React components
 * Single source of truth for icon rendering
 */
export const iconComponents: Record<IssueIconType, React.ElementType> = {
    error: XCircle,
    ban: Ban,
    warning: AlertTriangle,
    clock: Clock,
    help: HelpCircle,
    info: Info,
};

/**
 * Map severity to Tailwind class objects
 * Used by Drivers.tsx for badge styling
 */
export const severityClassColors: Record<IssueSeverity, { bg: string; text: string }> = {
    critical: { bg: 'bg-red-100', text: 'text-red-800' },
    warning: { bg: 'bg-yellow-100', text: 'text-yellow-800' },
    info: { bg: 'bg-gray-100', text: 'text-gray-800' },
};

/**
 * Map severity to simple color strings
 * Used by SitesPage.tsx for color system
 */
export const severityColorStrings: Record<IssueSeverity, string> = {
    critical: 'red',
    warning: 'yellow',
    info: 'gray',
};
